module.exports = __webpack_public_path__ + "static/media/login-background.421553fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-background.jpg
// module id = 449
// module chunks = 0